import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { Loading } from "element-ui"; //此处根据你实际使用的框架的loading进行引入
let loading;
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = Vue.prototype.getPdf = function(id, fileName) {
      return new Promise((resolve,reject) => {
		const ele = document.querySelector(`#${id}`);
		const css = document.querySelectorAll('.' + id)
		// document.body.appendChild(ele);
		// ele.style.width =  css[0].offsetWidth + 'px';
		// ele.style.height = css[0].offsetHeight + 'px';
		// ele.setAttribute("style","transform:scale(10);");

        html2Canvas(ele, {
          useCORS: false //看情况选用上面还是下面的，
        }).then(function(canvas) {
			// document.body.appendChild(canvas);
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
		  const now = new Date();
		  const year = now.getFullYear();
		  const month = now.getMonth() + 1; // 月份从0开始，需要加1
		  const day = now.getDate();
		  const dateStr = '_' + year + '年' + month + '月' + day + '日';

          PDF.save(fileName + dateStr + '.pdf')

          let pdfFlow = PDF.output('datauristring')//获取base64Pdf
          console.log(pdfFlow)

          resolve(pdfFlow)

          // resolve(pageData)      //获取base64png
        })
      })
    }
  }
};
